if (!customElements.get('sotto-quiz')) {
  customElements.define(
    'sotto-quiz',
    class SottoQuiz extends HTMLElement {
      constructor() {
        super();
        this.hero = this.querySelector('[data-sotto-quiz-hero]');
        this.container = this.querySelector('[data-sotto-quiz-container]');
        this.questions = Array.from(this.querySelectorAll('[data-sotto-question]'));
        this.dots = Array.from(this.querySelectorAll('[data-sotto-progress-dot]'));
        this.resultWrapper = this.querySelector('[data-sotto-result]');
        this.resultItems = Array.from(this.querySelectorAll('[data-sotto-result-item]'));
        this.answers = [];
        this.answerDetails = [];
        this.submitted = false;
      }

      connectedCallback() {
        const startButton = this.querySelector('[data-sotto-quiz-start]');
        if (startButton) startButton.addEventListener('click', () => this.start());

        const retakeButton = this.querySelector('[data-sotto-retake]');
        if (retakeButton) retakeButton.addEventListener('click', () => this.reset());

        this.questions.forEach((question, questionIndex) => {
          question.querySelectorAll('[data-sotto-option]').forEach((option) => {
            option.addEventListener('click', () => this.answer(questionIndex, option));
          });
        });

        if (this.hasAttribute('data-skip-intro')) this.start(false);
      }

      start(scroll = true) {
        if (this.hero) this.hero.hidden = true;
        this.container.hidden = false;
        if (scroll) this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      answer(questionIndex, option) {
        this.answers[questionIndex] = option.dataset.value;

        const questionEl = this.questions[questionIndex];
        const questionText = questionEl.querySelector('.sotto-quiz__q-text');
        this.answerDetails[questionIndex] = {
          question: questionText ? questionText.textContent.trim() : `Question ${questionIndex + 1}`,
          answer: option.textContent.trim(),
          value: option.dataset.value || '',
        };

        option.parentElement
          .querySelectorAll('[data-sotto-option]')
          .forEach((sibling) => sibling.classList.remove('is-selected'));
        option.classList.add('is-selected');

        if (this.dots[questionIndex]) this.dots[questionIndex].classList.add('is-filled');

        setTimeout(() => {
          if (questionIndex < this.questions.length - 1) {
            this.questions.forEach((question) => question.classList.remove('is-active'));
            this.questions[questionIndex + 1].classList.add('is-active');
            this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            this.showResult();
          }
        }, 400);
      }

      showResult() {
        const counts = {};
        this.answers.forEach((value) => {
          if (!value) return;
          counts[value] = (counts[value] || 0) + 1;
        });
        const winner = Object.entries(counts).sort((a, b) => b[1] - a[1])[0];
        if (!winner) return;

        const winningValue = winner[0];
        let matched =
          this.resultItems.find((item) => item.dataset.resultValue === winningValue) || this.resultItems[0];
        if (!matched) return;

        this.resultItems.forEach((item) => (item.hidden = true));
        matched.hidden = false;

        this.questions.forEach((question) => question.classList.remove('is-active'));
        this.resultWrapper.hidden = false;
        this.resultWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const resultName = matched.dataset.resultName || '';

        if (this.hasAttribute('data-store-result')) {
          try {
            localStorage.setItem('sotto_quiz_result', resultName);
          } catch (error) {
            // Storage unavailable (private mode) — ignore.
          }
        }

        if (this.hasAttribute('data-submit-form')) this.sendToContactForm(resultName);
      }

      sendToContactForm(resultName) {
        if (this.submitted) return; // Only send once per completed session.
        this.submitted = true;

        const sessionId =
          'SOTTO-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();

        const lines = this.answerDetails
          .filter(Boolean)
          .map((detail, index) => `${index + 1}. ${detail.question}\n   → ${detail.answer}`)
          .join('\n');

        const body =
          `Session ID: ${sessionId}\n` +
          `Date: ${new Date().toLocaleString()}\n` +
          `Recommended result: ${resultName}\n\n` +
          `Answers:\n${lines}`;

        const email = this.dataset.customerEmail || this.dataset.submitEmail || '';
        const name = this.dataset.customerName || this.dataset.submitName || 'Quiz visitor';

        const formData = new FormData();
        formData.append('form_type', 'contact');
        formData.append('utf8', '✓');
        formData.append('contact[email]', email);
        formData.append('contact[name]', name);
        formData.append('contact[Session ID]', sessionId);
        formData.append('contact[Recommended result]', resultName);
        formData.append('contact[Answers]', lines);
        formData.append('contact[body]', body);

        fetch('/contact', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        }).catch(() => {
          // Submission is best-effort; never block the result UI on a network error.
          this.submitted = false;
        });
      }

      reset() {
        this.answers = [];
        this.answerDetails = [];
        this.submitted = false;
        this.dots.forEach((dot) => dot.classList.remove('is-filled'));
        this.querySelectorAll('[data-sotto-option]').forEach((option) => option.classList.remove('is-selected'));
        this.questions.forEach((question) => question.classList.remove('is-active'));
        if (this.questions[0]) this.questions[0].classList.add('is-active');
        this.resultWrapper.hidden = true;
        this.resultItems.forEach((item) => (item.hidden = true));
        if (this.hero && !this.hasAttribute('data-skip-intro')) {
          this.hero.hidden = false;
          this.container.hidden = true;
          this.hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}
